<div class="card-body" style="position: relative;" *ngIf="isLoading">
    <div class="loading-buttons"
        style=" cursor: not-allowed !important; pointer-events: all !important; position: absolute;background: rgba(0, 0, 0, 0.2);border-radius: 12px;"
        id="loader-div1">
        <span class="loading-icon">
            <img src="assets/images/loader/spinner.gif" />
        </span>
    </div>
</div>
<div class="container py-5">

    <div class="row" *ngIf="!checkLinkExpiryFlag">
        <div class="col-md-12 terms-condition" *ngIf="disclaimerText" [innerHTML]="disclaimerText">

        </div>
        <div class="col-md-12 terms-condition" *ngIf="!disclaimerText">
            <h4>Disclaimer</h4>
            <p style="text-align:center;"><small>(To be explicitly agreed to, by the Subject, before commencement of
                    Video call)</small></p>
            <p style="margin-bottom:5px;"></p>

            <p>This identity verification video-call will require you to share some identity-related information and
                documents.</p>
            <p>This process is being carried out by Astute Corporate Services Pvt. Ltd. on behalf of <b
                    style="font-weight:500;">{{clientName}}</b></p>
            <p>By participating in this identity verification video- call, you confirm the following:</p>

            <ul>
                <li><span style="font-weight:500;">a.</span> You are voluntarily participating in this identity-
                    verification video call.</li>
                <li><span style="font-weight:500;">b.</span> Your selfie will be taken during the video call. Please
                    allow your device to share photos.</li>
                <li><span style="font-weight:500;">c.</span> As part of the video call, you will be required to provide
                    images of the name board of your business as it appears at the address, along with pictures of the
                    premises and stock.</li>
                <li><span style="font-weight:500;">d.</span> Photographs of address-proof and other documents will be
                    taken during the video call for necessary identity details to be captured.</li>
                <li><span style="font-weight:500;">e.</span> Your Geo-location will required to be captured during this
                    video- call. Please turn on location/ GPS services on your mobile device for this purpose.</li>
                <li><span style="font-weight:500;">f.</span> This Video Call will be recorded for Quality Monitoring,
                    Audit & Internal Training Purposes.</li>
            </ul>
        </div>
        <div class="col-md-12" style="text-align: center; margin-top:15px;">
            <label for="termsandconditions">
                <input type="checkbox" [(ngModel)]="isAccepted" class="checkbox" name="acceptterms"
                    id="termsandconditions"> <span class="px-1">I agree to terms and conditions</span>
            </label>
        </div>
    </div>
    <div class="row" *ngIf="checkLinkExpiryFlag">
        <div class="col-md-12 my-2" style="text-align: center;">
            <p>{{msg}}</p>
        </div>
    </div>

    <div class="row py-4" *ngIf="!checkLinkExpiryFlag">
        <div class="col-md-12 mt-2" style="text-align: center;">
            <button class="btn btn-primary accept-btn" [disabled]="!isAccepted"
                (click)="acceptTermsAndConditions()">Attend Video Call</button>
        </div>
    </div>


</div>